import React, { Component } from "react";
import { Button, Tabs, Icon, Tooltip, message, Modal } from "antd";
import SideNav from "../../businessOffer/SideNav";
import "./index.less";
import API_URL from "../../../common/url";
import $ from "../../../common/AjaxRequest";
import QuotationParams from "./components/QuotationParams";
import QuotationTotalPrice from "./components/QuotationTotalPrice";
import Cover from "./components/Cover";
import Intro from "./components/Intro";
import PaymentPlan from "./components/PaymentPlan";
import CrcServiceContent from "./CrcServiceContent";
import { saveEvaluateParams } from '../../../actions/clinicalEvaluationActions';
import { connect } from "react-redux";
import ExportVisitQuotation from "./components/ExportVisitQuotation";
import ServiceQuotationDetail from "./components/ServiceQuotationDetail";

const TabPane = Tabs.TabPane;

class FteQuotation extends Component {
    state = {
        recordData: {},
        quotationData: {},
        activeKey: "Cover",
        tipTitle: "",
        serveFeeType: "",
    };

    componentDidMount() {
        this.loadRecordData();
        this.getClinicalQuotationRecord();
    }

    loadRecordData = () => {
        const { evaluateRecordId } = this.props.match.params;
        const { evaluateParams: { isClinicalEvaluation } } = this.props;
        const url = isClinicalEvaluation ? API_URL.evaluate.queryEvaluateRecords : API_URL.evaluate.queryQuotationListByParams;
        const options = {
            method: "POST",
            url,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const { datas } = res;
                this.setState({
                    recordData: datas[0] || {},
                });
            },
        };
        $.sendRequest(options);
    };

    //获取报价单Id及tab页权限
    getClinicalQuotationRecord = () => {
        const { evaluateRecordId } = this.props.match.params;
        const options = {
            method: "POST",
            url: API_URL.evaluate.getClinicalFteQuotationRecord,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data } = res;
                this.setState(
                    {
                        quotationData: data,
                    },
                    () => {
                        this.queryServeFeeType(evaluateRecordId);
                    }
                );
            },
        };
        $.sendRequest(options);
    };

    queryServeFeeType = (evaluateRecordId) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                },() => {
                    this.queryQuotationFteFloating();
                })
            },
        };
        $.sendRequest(options);
    }

    

    queryQuotationFteFloating = () => {
        const {
            quotationData: { clinicalQuotationRecordId },
            serveFeeType,
        } = this.state;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryQuotationFteFloating,
            data: {
                clinicalQuotationRecordId,
                serveFeeType,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data } = res;
                let arr = (data || "").split("\n");
                let title = (
                    <div>
                        {arr.map((el) => (
                            <span>
                                {el}
                                <br />
                            </span>
                        ))}
                    </div>
                );
                this.setState({
                    tipTitle: title,
                });
            },
        };
        $.sendRequest(options);
    };

    handelTabChange = (value) => {
        this.setState({
            activeKey: value,
        });
    };

    publishQuote = () => {
        const { quotationData: { clinicalQuotationRecordId } } = this.state;
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{marginLeft: 42}}>确认要发布吗？</div>,
            onOk: () => {
                const options = {
                    method: "POST",
                    url:  API_URL.evaluate.publishFteClinicalQuotationRecord,
                    data: {
                        clinicalQuotationRecordId,
                        isSimple: 1,
                    },
                    dataType: "json",
                    doneResult: (res) => {
                        message.success(res.success);
                        this.hide();
                    },
                };
                $.sendRequest(options);
                    },
                });
        };

    export = () => {
        const { quotationData: { clinicalQuotationRecordId } } = this.state;
        const options = {
            method: "POST",
            url:  API_URL.evaluate.exportClinicalQuotationRecord,
            data: {
                clinicalQuotationRecordId,
                isSimple: 1,
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
            },
        };
        $.sendRequest(options);
    };

    leave = () => {
        this.props.saveEvaluateParams({ feedBack: true });
        window.history.go(-1);
    }

    render() {
        const { activeKey, recordData, quotationData, tipTitle } = this.state;
        const { evaluateCode, evaluateRecordId, evaluateStatus, bdBaAuth } = recordData;
        const {
            researchProductTypeId,
            evaluateServeCode,
            clinicalQuotationRecordId,
            paymentPlanHasInflation,
        } = quotationData || {};
        const params = {
            key: activeKey,
            activeKey,
            clinicalQuotationRecordId,
            recordData,
        }
        const TabsConfig = [
            {
                title: "封面",
                key: "Cover",
                Dom: (
                    <Cover 
                        evaluateRecordId={evaluateRecordId}
                        clinicalQuotationRecordId={clinicalQuotationRecordId}
                        recordData={recordData}
                    />
                ),
            },
            {
                title: "公司简介",
                key: "Intro",
                Dom: (
                    <Intro 
                        {...params}
                    />
                ),
            },
            {
                title: "报价参数",
                key: "QuotationParams",
                Dom: (
                    <QuotationParams 
                        {...params}
                    />
                ),
            },
            {
                title: "总价",
                key: "FteSimpleTotalPrice",
                Dom: (
                    <QuotationTotalPrice
                        {...params}
                    />
                ),
            },
            {
                title: "服务报价明细",
                key: "ServiceQuotationDetail",
                Dom: (
                    <ServiceQuotationDetail
                        {...params}
                    />
                ),
            },
            {
                title: "CRC服务内容",
                key: "CRCServiceContent",
                show: researchProductTypeId != 5,
                Dom: <CrcServiceContent
                        tabType="FteCrc"
                        {...params}
                    />,
            },
            {
                title: "CRC服务内容-器械",
                key: "CRCServiceContentInstrument",
                show: researchProductTypeId == 5,
                Dom: <CrcServiceContent
                        tabType="FteCrc"
                        {...params}
                    />,
            },
            {
                title: "全权启动-服务内容",
                key: "fullStartServiceContent",
                show: evaluateServeCode == "start_plenipotentiary",
                Dom: <CrcServiceContent
                        tabType="FteStart"
                        {...params}
                    />,
            },
            {
                title: "主导启动-服务内容",
                key: "dominantStartServiceContent",
                show: evaluateServeCode == "start_leading",
                Dom: <CrcServiceContent
                        tabType="FteStart"
                        {...params}
                    />,
            },
            {
                title: "深度协助-服务内容",
                key: "deepAssistServiceContent",
                show: evaluateServeCode == "start_deeply_assist",
                Dom: <CrcServiceContent
                        tabType="FteStart"
                        {...params}
                    />,
            },
            {
                title: "基础协助-服务内容",
                key: "basicAssistServiceContent",
                show: evaluateServeCode == "start_ordinary_assist",
                Dom: <CrcServiceContent
                        tabType="FteStart"
                        {...params}
                    />,
            },
            {
                title: "付款时间表",
                key: "FteSimplePaymentPlan",
                Dom: (
                    <PaymentPlan
                        {...params}
                        getClinicalQuotationRecord={this.getClinicalQuotationRecord}
                        paymentPlanHasInflation={paymentPlanHasInflation}
                    />
                ),
            },
        ];
        return (
            <div className="content visitAssess">
                <SideNav selectKey="record" />
                <div className="main">
                <div className="tab_fixed">
                    <div style={{ overflow: "hidden" }}>
                        <div
                            style={{
                                float: "left",
                                margin: "10px",
                                marginTop: 0,
                            }}
                        >
                            <i
                                className="icon iconfont"
                                style={{
                                    marginRight: 4,
                                    fontSize: "20px",
                                    color: "#1296DB",
                                }}
                            >
                                &#xe65b;
                            </i>
                            {`临床评估单号：${evaluateCode}`}
                        </div>
                        <Button
                            type="primary"
                            className="export—btn"
                            onClick={() => this.export()}
                        >
                            导出
                        </Button>
                        {
                            (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                <Button
                                    className="btn-yellow"
                                    style={{ marginLeft: 10 }}
                                    onClick={() => this.publishQuote()}
                                >
                                    发布报价
                                </Button>
                        }
                        <div
                            style={{
                                float: "right",
                                marginRight: 10,
                                color: "#1296DB",
                                cursor: "pointer",
                            }}
                            onClick={() => this.leave()}
                        >
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: "20px" }}
                            >
                                &#xe63d;
                            </i>
                            返回
                        </div>
                    </div>
                        <Tabs
                            onChange={this.handelTabChange}
                            type="card"
                            activeKey={activeKey}
                        >
                            {TabsConfig.map((teb) => {
                                const { show = true } = teb;
                                if (show)
                                    return (
                                        <TabPane tab={teb.title} key={teb.key}>
                                        </TabPane>
                                    );
                            })}
                        </Tabs>
                    </div>
                    {TabsConfig.find(el => el.key === activeKey).Dom}
                </div>
                <Tooltip
                    placement="left"
                    title={tipTitle}
                    overlayClassName="head_tip"
                >
                    <a className="floatingIcon" onMouseEnter={() => this.queryQuotationFteFloating()}>
                        <Icon type="appstore-o" style={{ fontSize: 25 }} />
                    </a>
                </Tooltip>
                <ExportVisitQuotation ref={el => this.ExportVisitQuotationRef = el}/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        evaluateParams: state.clinicalEvaluationState.evaluateParams,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveEvaluateParams: (params) => dispatch(saveEvaluateParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FteQuotation);



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FteQuotation.js